import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "Chuyên Nghiệp",
  icon: "💼",
  templates: [
    {
      title: "Kịch Bản YouTube / Video",
      content: `Viết kịch bản cho video YouTube do một người thuyết minh.
- Chủ đề video là [5 sai lầm phổ biến khi làm việc tại nhà — và cách khắc phục].
- Đối tượng mục tiêu: [chuyên gia trẻ bắt đầu công việc từ xa đầu tiên].
- Giọng điệu: [thân thiện, đối thoại và thực tế — như lời khuyên từ một đồng nghiệp đáng tin cậy].
- Cấu trúc với câu mở đầu hấp dẫn trong hai câu đầu, chuyển tiếp rõ ràng giữa các điểm, và phần kết ngắn gọn với lời kêu gọi hành động.
- Viết cho phần nói: sử dụng đoạn ngắn và câu hỏi tu từ để giữ sự chú ý của người nghe.`
    },
    {
      title: "Giải Thích Sản Phẩm",
      content: `Viết kịch bản lồng tiếng cho video giải thích sản phẩm.
- Sản phẩm là [ứng dụng di động giúp chủ doanh nghiệp nhỏ theo dõi chi phí bằng cách quét hóa đơn].
- Đối tượng mục tiêu: [freelancer và chủ doanh nghiệp nhỏ ghét việc sổ sách kế toán].
- Lợi ích chính cần nêu bật:
  1. [Quét hóa đơn trong 2 giây — không cần nhập thủ công].
  2. [Tự động phân loại chi phí với gợi ý thông minh].
  3. [Xuất một chạm cho mùa khai thuế].
- Giọng điệu: [rõ ràng, tươi vui và an tâm — biến việc đau đầu thành dễ dàng].
- Giữ câu ngắn gọn và mạnh mẽ. Tránh thuật ngữ chuyên môn.`
    },
    {
      title: "Bài Phát Biểu Thuyết Trình",
      content: `Viết bài phát biểu cho buổi thuyết trình chuyên nghiệp hoặc diễn thuyết chính.
- Dịp là [cuộc họp toàn công ty để khởi động quý mới].
- Diễn giả là [một trưởng nhóm phát biểu trước đối tượng hỗn hợp gồm kỹ sư, nhà thiết kế và quản lý].
- Thông điệp cốt lõi: [kỷ niệm thành tích quý trước, thừa nhận thách thức một cách trung thực, và tập hợp đội ngũ xung quanh trọng tâm rõ ràng cho những tháng tới].
- Giọng điệu: [tự tin, chân thành và truyền cảm hứng — không phải ngôn ngữ công ty sáo rỗng].
- Thời lượng nói ước tính: [4 phút].
- Sử dụng cách diễn đạt đối thoại, khoảng dừng chiến lược và câu kết ấn tượng.`
    }
  ]
};
